import { OrderableScenarioSelect } from "components/UI/Selects/OrderableScenarioSelect/OrderableScenarioSelect";
import { ConnectionCreatorScenarioCategory } from "types/enums";

import ScenarioOrderItemRequest = App.Http.Requests.FormField.ScenarioOrderItemRequest;

interface Props {
    value?: ScenarioOrderItemRequest[];
    onChange?: (value: ScenarioOrderItemRequest[]) => void;
    placeholder?: string;
    disabled?: boolean;
    formStructureId?: string;
}

export const StructureAutocompleteScenarioSelectSearchable = (props: Props) => {
    return (
        <OrderableScenarioSelect
            filter={{
                sort: "title",
                filter: {
                    category: ConnectionCreatorScenarioCategory.StructureAutocomplete,
                },
            }}
            {...props}
        />
    );
};
